export default {
	"query": {
		"queryToAccept": "受理",
		"isProject": "是否项目",
		"customerName": "客户名称",
		"packingWay": "包装方式",
		"distributionTimes": "配送频次",
		"startTime": "预计启动日期",
		"neededUnloading": "配送渠道",
		"lastFile": "上次附件",
		"ageingRequirements": "时效要求",
		"acceptTime": "受理时间",
		"acceptName": "受理人",
		"handleTime": "申请时间",
		"handlePerson": "申请人",
		"note": "备注信息",
		"feedBack": "反馈信息",
		"submitUser": "提交人",
		"transportationType": "运输类型",
		"submitTime": "提交时间",
		"customerProfile": "客户简介",
		"temperatureRule": "温度要求",
		"applicationInformation": "申请信息"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/query/query.js